module.exports = __webpack_public_path__ + "img/ky.fdbcaf43.svg";